<template>
    <section id="unauthorized-page">
        <div class="unauthorized">
            <v-icon class="unauthorized__icon">mdi-lock-outline</v-icon>
            <div class="unauthorized__text">
                <p>Unauthorized.</p>
                <p>Please contact your Permissions Administrator for help.</p>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'Unauthorized',
};
</script>

<style scoped lang="scss">
#unauthorized-page {
    height: 50vh;
    display: flex;
    flex-flow: row nowrap;

    .unauthorized {
        display: flex;
        flex-flow: row nowrap;
        margin: auto;

        &__icon {
            font-size: 120px;
        }

        &__text {
            display: flex;
            flex-flow: column nowrap;
            margin-top: auto;
            margin-bottom: auto;
            margin-left: 1rem;
        }
    }
}

</style>
